//Onepage steps checkout setup and interactivity, may be separated into 2 plugins eventually

bq.onepageSteps = function(element, options) {
  this.options   = options;
  this.$element  = $(element);
  this.singleModeContainerSelector = '.single-mode-container';
  this.multipleModeContainerSelector = '.multiple-mode-container';
};

bq.onepageSteps.DEFAULTS = {};

bq.onepageSteps.prototype = {

  init: function() {

    var self = this;

    bq.debug.log("Onepage Steps : init()", this.$form);

    $(self.multipleModeContainerSelector).find('input, textarea')
        .addClass('deactivate-validation')
        .prop('disabled', 'disabled');

    this.$element.on('click', '.trigger-multiple-mode', function(e){
      var $this = $(this);
      var $modeParent = $($('#onepage-steps-container').children()[0]);
      var $singleMode = $modeParent.find(self.singleModeContainerSelector);
      var ajaxContainerSelector = $this.data('ajax-container');
      $singleMode.hide();
      $modeParent.find(self.multipleModeContainerSelector)
          .show()
          .find('input, textarea')
          .removeClass('deactivate-validation')
          .prop('disabled', false);
      $modeParent.find(self.singleModeContainerSelector)
          .find('input')
          .addClass('deactivate-validation');

      $this.addClass('current');
      $modeParent.find('button.trigger-single-mode').removeClass('current');

      bq.global.parsley.destroy();
      $('.form-control-feedback', self.singleModeContainerSelector).tooltip('destroy').remove();
      bq.global.parsley.setup();
      if ($('#accounting_use_header_level')) {
        $('#accounting_use_header_level').val("0");
      }
      if ($('#shipping_use_header_level')) {
          $('#shipping_use_header_level').val("0");
      }

      var $ajaxContainer = $(ajaxContainerSelector);
      self._initBottomButtons('multiple', $ajaxContainer);

      e.preventDefault();
    });

    this.$element.on('click', '.trigger-single-mode', function(e){
      var $this = $(this);
      var $modeParent = $($('#onepage-steps-container').children()[0]);
      var $multiMode = $modeParent.find(self.multipleModeContainerSelector);
      var ajaxContainerSelector = $this.data('ajax-container');

      $multiMode.hide();
      $modeParent.find(self.singleModeContainerSelector)
          .show()
          .find('input')
          .removeClass('deactivate-validation');
      $modeParent.find(self.multipleModeContainerSelector)
          .find('input, textarea')
          .addClass('deactivate-validation')
          .prop('disabled', 'disabled');

      $(this).addClass('current');
      $modeParent.find('button.trigger-multiple-mode').removeClass('current');

      bq.global.parsley.destroy();
      $('.form-control-feedback', self.multipleModeContainerSelector).tooltip('destroy').remove();
      bq.global.parsley.setup();
      if ($('#accounting_use_header_level')) {
        $('#accounting_use_header_level').val("1");
      }
      if ($('#shipping_use_header_level')) {
          $('#shipping_use_header_level').val("1");
      }

      var $ajaxContainer = $(ajaxContainerSelector);
      self._initBottomButtons('', $ajaxContainer);

      e.preventDefault();
    });

    this.$element.on('click', '[data-ajax-multi-location]', this._bindMultiLocationObserver.bind(this));

    this.$element.on('click', '[data-step-continue]', function (e) {
      var parentClass = self.singleModeContainerSelector;

      if($(self.multipleModeContainerSelector).is(':visible')){
        parentClass = self.multipleModeContainerSelector;
      }

      $(parentClass + ' .accounting-form:not(.hide) [data-parsley-required]').each(function(){
        $(this).parsley().validate();
      });

      if($(parentClass + ' .accounting-form:not(.hide) .form-validation-error').length) {
        $('html, body').animate({
          scrollTop: $($(parentClass + ' .form-validation-error')[0]).offset().top
        });

        return false;
      }

      var isShipValid = true;
      $('.shipping-select-box').parents('form').each(function(){
        var form = $(this);
        form.parsley().validate();
        if ($('.has-error', form).length) {
          isShipValid = false;
        }
      });

      if (!isShipValid) {
        $('html, body').animate({
          scrollTop: $($('.has-error')[0]).offset().top
        });
        return false;
      }

      bq.helper.throwEvent('bq.viewhandler.start', self.$element);
      bq.helper.throwEvent('bq.documentwizard.submit', self.$element);

      e.preventDefault();
      return false;
    });

    if ($('#shipping_use_header_level') && $('#shipping_use_header_level').val() != '1') {
      this.$element.find('.trigger-multiple-mode').click();
    }

    this.$element.on('click', '[data-ajax-button][data-cancel-edit]', this._bindMultiLocationObserver.bind(this))

    this.$element.on('click', '[data-ajax-button][data-save-edit]', function (e) {
      var $this = $(this);
      var ajaxContainerSelector = $this.data('ajax-container');

      if (!$this.data('ajax-url') || $this[0].hasAttribute('data-disabled')) {
        e.preventDefault();
        return;
      }

      var $gridMultiLocation = $(ajaxContainerSelector).find('.onepage-grid-multi-location').first();
      if ($gridMultiLocation.length > 0) {
        self._onSaveMultiLocation($gridMultiLocation, e);
        e.preventDefault();
      }
    });

    var $ajaxContainer = $('#checkoutlite_step_shipping_lines_wrapper');
    if ($ajaxContainer.find('.onepage-grid-multi-location').length) {
      self._watchMainControls($ajaxContainer);
      $('.multi-shipping-explanation').hide();
    }
  },

  _initBottomButtons: function(mode, $ajaxContainer) {
    if (mode === 'multiple' && $ajaxContainer.find('.onepage-grid-multi-location').length) {
      $('.onepage-shipping-actions').hide();
      $('.onepage-shipping-multi-locations-actions').show();
    } else {
      $('.onepage-shipping-actions').show();
      $('.onepage-shipping-multi-locations-actions').hide();
    }
  },

  _bindMultiLocationObserver: function(e) {
    e.preventDefault();
    var self = this;
    var $this = $(e.target);
    var ajaxContainerSelector = $this.data('ajax-container');
    var $ajaxContainer = $(ajaxContainerSelector);

    bq.helper.throwEvent('bq.viewhandler.progressmessage', $ajaxContainer, {
      message: $this.data('view-handler-message'),
    });

    $.ajax({
      type: 'post',
      url: $this.data('ajax-url'),
      dataType: 'json',
      success: function(response) {
        if (!response || !response.html) {
          console.warn('Response is invalid.', response);
          return;
        }

        try {
          if (response.updates) {
            response.updates.forEach(function (obj) {
              $(obj.selector).html(obj.content);
            });
          }
          if (response.html) {
            $ajaxContainer.html(response.html);
          }
        } catch (exception) {
        }

        self._initBottomButtons('multiple', $ajaxContainer);
        self._watchMainControls($ajaxContainer);
        if ($this.data('ajax-multi-location') === undefined) {
          $('.multi-shipping-explanation').show();
        } else {
          $('.multi-shipping-explanation').hide();
        }

      },
      complete: function() {
        bq.helper.throwEvent('bq.viewhandler.stop', $('#checkoutlite_step_shipping_lines_wrapper'));
      },
    });
  },

  _watchMainControls: function($container) {
    $container.find('[data-multi-location-main-form-control]').each(function() {
      var $control = $(this);
      var $controlName = $control.data('multi-location-main-form-control');
      var $applyToAllButton = $('[data-multi-location-applyall="' + $controlName + '"]').first();

      if ($applyToAllButton.length === 0) {
        return;
      }

      $applyToAllButton.on('click', function() {
        var item = $('[name="' + $controlName + '"][data-multi-location-id]');

        item.prop('checked', true);
        item.val($control.val());
      });
    });
    $container.find('input[type="checkbox"]').on('click', function() {
      var self = $(this);
      if (self.is(':checked')) {
        self.val(1);
      } else {
        self.val(0);
      }
    });
  },

  _onSaveMultiLocation: function($container, event) {
    var self = this;
    var $eventTarget = $(event.target);
    var submitUrl = $eventTarget.data('ajax-url');
    var $ajaxContainer = $($eventTarget.data('ajax-container'));
    var vhMessage = $eventTarget.data('view-handler-message');
    var formData = new FormData();
    formData.append('form_key', $container.find('[name=form_key]').val());
    formData.append('item_id', $container.find('[name=item_id]').val());

    $container.find('td [data-multi-location-id]').each(function(i, control) {
      var $control = $(control);
      var locationId = $control.data('multi-location-id');
      var controlName = $control.attr('name');
      var value = $control.val();

      formData.append('items[locations][' + locationId + '][' + controlName + ']', value);
    });

    bq.helper.throwEvent('bq.viewhandler.progressmessage', this.$element, {
      message: vhMessage,
    });

    var hasErrors, forwarded = false;

    $.ajax({
      url: submitUrl,
      type: 'POST',
      data: formData,
      cache: false,
      processData: false,
      contentType: false,
      success: function(response) {
        var data = JSON.parse(response);

        if ('errors' in data && data.errors.length > 0) {
          data.errors.forEach(function(obj, index) {
            bq.helper.throwEvent('bq.notification', $(document), {
              id: 'notification_bq-ui-' + index,
              text: obj.message,
              type: 'error'
            });
          });

          hasErrors = true;
          return;
        }

        if ('forward' in data) {
          forwarded = true;
          setLocation(data.forward);
          return;
        }

        if (!('html' in data)) {
          console.error('Received invalid response.');
          hasErrors = true;
          return;
        }
        $ajaxContainer.html(data.html);

        var responseObj = data;
        if (responseObj.update) {
          if (typeof(responseObj.update) === 'object') {
            $.each(responseObj.update, function (k, v) {
              if (v.target) {
                $(v.target).html(v.html);
              }
            });
          } else if (responseObj.update.target && responseObj.update.html) {
            $(responseObj.update.target).html(responseObj.update.html);
          }
        }
      },
      complete: function() {
        if (!forwarded) {
          bq.helper.throwEvent('bq.viewhandler.stop', $('[data-view-handler]'));
        }
        if (hasErrors) {
          return;
        }
        
        self._initBottomButtons('', $ajaxContainer);
        $('.multi-shipping-explanation').show();
      },
    });
  },
};  

// onepageSteps PLUGIN DEFINITION
// =======================

var onepageStepsold = $.fn.onepageSteps;

$.fn.onepageSteps = function (option, _relatedTarget) {
  return this.each(function () {
    var $this   = $(this);
    var data    = $this.data('bq.onepageSteps');
    var options = $.extend({}, bq.onepageSteps.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

    if (!data) { $this.data('bq.onepageSteps', (data = new bq.onepageSteps(this, options))); }
    data.init();
  });
};

$.fn.onepageSteps.Constructor = bq.onepageSteps;

// onepageSteps NO CONFLICT
// =================

$.fn.onepageSteps.noConflict = function () {
  $.fn.onepageSteps = onepageStepsold;
  return this;
};

// onepageSteps DATA-API
// ==============

bq.onepageStepsInit = function() {
  $('[data-onepage-steps-init]').each(function () {
    var el = $(this);
    if(el.data('bq.onepageSteps')) { return; }
    el.onepageSteps(el.data());
  });
};

bq.init.push(bq.onepageStepsInit);